// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 28V10.64a16.98 16.98 0 0028 0V28H4zM31.27 8A15 15 0 014.73 8h26.54zM2 6v24h32V6H2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;